import React, { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import uuid4 from 'uuid';
import FlatCard from '../FlatCard';
import Spinner from '../../Spinner/Spinner';

const Content = styled.div`
  display: grid;
  grid-gap: 1rem;
  grid-template-rows: 1fr auto;
`;

const FlatCards = styled.div`
  display: grid;
  grid-gap: 0.5rem;

  ${props => props.limit
    && css`
      max-height: 60vh;
      overflow: scroll;
      -webkit-overflow-scrolling: touch;
      padding: 0.5rem;
    `};
`;

const Message = styled.p`
  color: var(--font-color-faded);

  ${props => props.error
    && `
    color: var(--color-red);
    filter: opacity(0.7),
  `}
`;

const TeacherContent = ({
  className,
  teacher,
  getClassroomStudents,
  classroomId,
  unassignStudent,
}) => {
  const [students, setStudents] = useState([]);
  const { data, fetching, error } = teacher;
  const cardsEmpty = data.length === 0;
  const cardsLong = data.length > 5;

  useEffect(() => {
    getClassroomStudents(classroomId);
  }, []);

  useEffect(() => {
    if (data.length !== students.length) {
      setStudents(data);
    }
  }, [data]);

  return (
    <Content>
      <h4>{`Schüler der Klasse ${className}`}</h4>
      <FlatCards limit={cardsLong}>
        {fetching && <Spinner big />}
        {!cardsEmpty
          && !fetching
          && students.map(card => (
            <FlatCard
              key={uuid4()}
              card={card}
              unassignStudent={() => unassignStudent(classroomId, card.id)}
            />
          ))}
        {cardsEmpty && !fetching && !error && (
          <Message>Dieser Klasse wurden noch keine Schüler zugewiesen.</Message>
        )}
        {error && <Message error>Es ist ein Fehler aufgetreten.</Message>}
      </FlatCards>
    </Content>
  );
};

export default TeacherContent;



// WEBPACK FOOTER //
// ./src/components/Sidebar/Teacher/TeacherContent.jsx